import React, { useState } from "react";
import "./Chatbot.css"; // CSS modernisé déjà fait

export default function Chatbot() {
  const [isOpen, setIsOpen] = useState(false);
  const [messages, setMessages] = useState([
    { from: "bot", text: "Bonjour 👋 ! Comment puis-je vous aider aujourd'hui ?" },
  ]);
  const [input, setInput] = useState("");

  // 💬 Envoi d’un message (LOGIQUE CONSERVÉE, RÉPONSES ENRICHIES)
  const handleSend = () => {
    if (input.trim() === "") return;

    const newMessages = [...messages, { from: "user", text: input }];
    setMessages(newMessages);
    setInput("");

    // 🧠 Réponse automatique enrichie
    setTimeout(() => {
      let botReply =
        "Je ne suis pas sûr de comprendre 🤔. Pouvez-vous préciser votre demande ?";

      const lower = input.toLowerCase();

      /* ===== SALUTATIONS ===== */
      if (
        lower.includes("bonjour") ||
        lower.includes("salut") ||
        lower.includes("hello") ||
        lower.includes("bonsoir")
      ) {
        botReply =
          "Bonjour 👋 ! Je suis l’assistant HDC Éducation. Comment puis-je vous aider ?";
      }

      /* ===== COURS / FORMATIONS ===== */
      else if (
        lower.includes("cours") ||
        lower.includes("formation") ||
        lower.includes("apprendre") ||
        lower.includes("pdf")
      ) {
        botReply =
          "📘 Vous pouvez accéder à nos cours depuis la section « Cours ». " +
          "Recherchez une matière (Python, IA, Cloud, ERP…) pour trouver des ressources PDF adaptées.";
      }

      else if (
        lower.includes("python") ||
        lower.includes("ia") ||
        lower.includes("intelligence artificielle") ||
        lower.includes("cloud") ||
        lower.includes("erp") ||
        lower.includes("data")
      ) {
        botReply =
          "📚 Excellent choix ! Allez dans la page « Cours » et recherchez la technologie souhaitée " +
          "(ex : Python débutant, IA PDF, Cloud computing, ERP…).";
      }

      /* ===== PROFILS ===== */
      else if (
        lower.includes("eleve") ||
        lower.includes("étudiant") ||
        lower.includes("etudiant")
      ) {
        botReply =
          "👨‍🎓 En tant qu’élève ou étudiant, vous pouvez accéder à des cours adaptés et rechercher un accompagnement depuis la page Accueil.";
      }

      else if (lower.includes("tuteur")) {
        botReply =
          "👨‍🏫 Vous souhaitez devenir tuteur ? Sélectionnez le profil « Tuteur » depuis la page Accueil pour candidater.";
      }

      else if (
        lower.includes("ecole") ||
        lower.includes("école") ||
        lower.includes("établissement") ||
        lower.includes("partenariat")
      ) {
        botReply =
          "🏫 Les écoles peuvent établir un partenariat avec HDC Éducation. " +
          "Nous vous invitons à nous contacter via la page « Contact ».";
      }

      /* ===== CONTACT / RDV ===== */
      else if (
        lower.includes("contact") ||
        lower.includes("message") ||
        lower.includes("email")
      ) {
        botReply =
          "📞 Vous pouvez nous contacter via la page « Contact » en remplissant le formulaire prévu à cet effet.";
      }

      else if (
        lower.includes("rendez") ||
        lower.includes("rdv") ||
        lower.includes("meeting") ||
        lower.includes("appel")
      ) {
        botReply =
          "📅 Vous pouvez réserver un rendez-vous de 30 minutes directement depuis la page « Contact » grâce au calendrier intégré.";
      }

      /* ===== FONCTIONNEMENT ===== */
      else if (
        lower.includes("comment") ||
        lower.includes("fonctionne") ||
        lower.includes("utiliser")
      ) {
        botReply =
          "ℹ️ HDC Éducation est une plateforme qui connecte élèves, tuteurs et écoles. " +
          "Vous pouvez consulter des cours, contacter l’équipe ou prendre rendez-vous facilement.";
      }

      /* ===== TARIFS / GRATUIT ===== */
      else if (
        lower.includes("prix") ||
        lower.includes("tarif") ||
        lower.includes("gratuit")
      ) {
        botReply =
          "💡 Certains contenus sont accessibles librement. Pour un accompagnement personnalisé, " +
          "nous vous invitons à nous contacter ou à prendre rendez-vous.";
      }

      /* ===== AIDE / SUPPORT ===== */
      else if (
        lower.includes("aide") ||
        lower.includes("support") ||
        lower.includes("problème")
      ) {
        botReply =
          "🆘 Je suis là pour vous aider. Vous pouvez me poser une question ou contacter directement l’équipe via la page « Contact ».";
      }

      /* ===== REMERCIEMENTS ===== */
      else if (lower.includes("merci") || lower.includes("thanks")) {
        botReply =
          "Avec plaisir 😊 ! N’hésitez pas si vous avez d’autres questions.";
      }

      /* ===== FALLBACK INTELLIGENT ===== */
      else {
        botReply =
          "🤔 Je peux vous aider sur : les cours, les profils (élève, tuteur, école), " +
          "le contact ou la prise de rendez-vous. Que souhaitez-vous faire ?";
      }

      setMessages((prev) => [...prev, { from: "bot", text: botReply }]);
    }, 700);
  };

  return (
    <div className="chatbot-container">
      {isOpen ? (
        <div className="chatbot-box" role="dialog" aria-label="Assistant HDC">
          {/* === Header === */}
          <div className="chatbot-header">
            <span>💬 Assistant HDC</span>
            <button
              onClick={() => setIsOpen(false)}
              aria-label="Fermer le chatbot"
              title="Fermer"
            >
              ✖
            </button>
          </div>

          {/* === Messages === */}
          <div className="chatbot-messages">
            {messages.map((msg, index) => (
              <div
                key={index}
                className={`chatbot-message ${
                  msg.from === "user" ? "user" : "bot"
                }`}
              >
                {msg.text}
              </div>
            ))}
          </div>

          {/* === Input === */}
          <div className="chatbot-input">
            <input
              type="text"
              placeholder="Posez votre question…"
              value={input}
              onChange={(e) => setInput(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && handleSend()}
              aria-label="Message"
            />
            <button onClick={handleSend} aria-label="Envoyer">
              ➤
            </button>
          </div>
        </div>
      ) : (
        <button
          className="chatbot-toggle"
          onClick={() => setIsOpen(true)}
          aria-label="Ouvrir le chatbot"
          title="Besoin d’aide ?"
        >
          💬
        </button>
      )}
    </div>
  );
}
